import { h } from 'preact'
import Icon from '../assets'
import Tooltip from '../ui-components/Tooltip'

interface GraphTitleProps {
    title: string,
    customClass?: string,
    tooltipMessage?: string
}

export const GraphTitle = ({ customClass, title, tooltipMessage } : GraphTitleProps) => (
  <div className={`graph-title ${customClass || ''}`}> {title} {tooltipMessage && <Tooltip
    position='left'
    trigger={<Icon icon='question' width={16} height={16} customClass='icon-info' />}
    customClasses='graph-help-tooltip'
    tooltipMessage={tooltipMessage}
  />}
  </div>
)
